import HttpClientToken from '../../services/HttpClientToken';

import { defaultProceso, ProcesoProps } from '../../interfaces/catalogos/ProcesoInterface';

export const Proceso = () => {

    return new Promise<ProcesoProps[]>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.get('/Api/Proceso/', token)
            .then( ({ data } : { data : ProcesoProps[] } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( [] );
            });

        }

    });

}

export const ObtenerProceso = () => {

    return new Promise<ProcesoProps[]>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.get('/Api/Proceso/ObtenerProceso', token)
            .then( ({ data } : { data : ProcesoProps[] } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( [] );
            });

        }

    });

}

export const ActualizarProceso = ( params: ProcesoProps ) => {

    return new Promise<ProcesoProps>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/Proceso/Actualizar', params, token)
            .then( ({ data } : { data : ProcesoProps} ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( { ...defaultProceso } );
            });

        }

    });

}

export const AgregarProceso = ( params: ProcesoProps ) => {

    return new Promise<ProcesoProps>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/Proceso/Agregar', params, token)
            .then( ({ data } : { data : ProcesoProps} ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( { ...defaultProceso } );
            });

        }

    });

}
